import { accountMenuConfig, AccountMenuRouteConfig } from "config/navigation";
import { Permission } from "../../types";

export const getAccountPages = (): (AccountMenuRouteConfig & {
  requiredPermission?: Permission;
})[] => {
  return accountMenuConfig.map(
    ({ path, translationKey, badgeKey, requiredPermission, featureFlag }) => {
      return {
        translationKey,
        path,
        requiredPermission,
        featureFlag,
        badgeKey
      };
    }
  );
};
